export default {
  importPaymentsRequest (state) {
    state.loading = true
  },
  importPaymentsSuccess (state, data) {
    state.loading = false
  },
  importPaymentsFailure (state) {
    state.loading = false
  },

  getPaymentByIDRequest (state) {
    state.payment = {}
  },
  getPaymentByIDSuccess (state, data) {
    state.payment = data
  },
  getPaymentByIDFailure (state) {
    state.payment = {}
  },

  getPaymentsRequest (state) {
    state.payments = []
  },
  getPaymentsSuccess (state, data) {
    state.payments = data
  },
  getPaymentsFailure (state) {
    state.payments = []
  },
  getPaymentsByEnrollmentIdRequest (state) {
    state.loading = true
    state.payments = []
  },
  getPaymentsByEnrollmentIdSuccess (state, data) {
    state.loading = false
    state.payments = data
  },
  getPaymentsByEnrollmentIdFailure (state) {
    state.loading = false
    state.payments = []
  },
  addPaymentRequest (state) {
    state.loading = true
  },
  addPaymentSuccess (state, data) {
    state.loading = false
  },
  addPaymentFailure (state) {
    state.loading = false
  },
  updatePaymentRequest (state) {
    state.loading = true
  },
  updatePaymentSuccess (state, data) {
    state.loading = false
  },
  updatePaymentFailure (state) {
    state.loading = false
  },
  deletePaymentRequest(state) {
    state.loading = true
  },
  deletePaymentSuccess(state) {
    state.loading = false
  },
  deletePaymentFailure(state) {
    state.loading = false
  },
}
